import { HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class CacheService {
  private cache = new Map<string, [HttpResponse<any>]>();

  /**
   * Store a value in the cache.
   * @param key the key to store the value under.
   * @param value the value to store.
   */
  public set(key: string, value: HttpResponse<any>) {
    this.cache.set(key, [value]);
  }

  /**
   * Retrieve a value from the cache.
   * @param key the key to retrieve the value for.
   * @returns the stored value or null if not found.
   */
  public get(key: string): HttpResponse<any> | null {
    const tuple = this.cache.get(key);
    if (!tuple) return null;
    const httpSavedResponse = tuple[0];
    return httpSavedResponse;
  }

  /**
   * Remove a value from the cache.
   * @param key the key to remove the value for.
   */
  public delete(key: string) {
    this.cache.delete(key);
  }

  /**
   * Clear the cache.
   */
  public clear() {
    this.cache.clear();
  }
}
